import { EXPIRATION_KEY, TOKEN_KEY, TOKEN_TTL_MS } from "./config";

export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);

export const getStoredExpiration = () => localStorage.getItem(EXPIRATION_KEY);

export const isSessionValid = () => {
  const token = getStoredToken();
  const expiration = getStoredExpiration();
  return Boolean(token && expiration && Date.now() < Number(expiration));
};

export const persistAuthSession = (accessToken: string) => {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(EXPIRATION_KEY, `${Date.now() + TOKEN_TTL_MS}`);
};

export const clearAuthSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRATION_KEY);
};

export const touchSessionExpiration = () => {
  localStorage.setItem(EXPIRATION_KEY, `${Date.now() + TOKEN_TTL_MS}`);
};
